/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_TInputs */

const en_tut_kantor_t = /** @type {(inputs: Tut_Kantor_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entering the office and reading the map`)
};

const id_tut_kantor_t = /** @type {(inputs: Tut_Kantor_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk kantor dan membaca petanya`)
};

/**
* | output |
* | --- |
* | "Entering the office and reading the map" |
*
* @param {Tut_Kantor_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_t = /** @type {((inputs?: Tut_Kantor_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_t(inputs)
	return en_tut_kantor_t(inputs)
});